import React from "react";
import { useCartContext } from "../Context/CartContext.jsx";
import CartPageProduct from "../Components/Menu/CartPageProduct.jsx";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

export const CartPage = () => {
  const navigate = useNavigate();
  const { products, subtotal } = useCartContext();
  return (
    <div
      className={`relative flex flex-col w-[100%] w-full h-full bg-white shadow-[-3px_0px_0px_0px] shadow-slate-200 pb-4`}
    >
      <div className="sticky top-0 left-0 flex flex-col bg-white z-[10000] flex-wrap justify-evenly">
        <div
          className="flex gap-1 items-center pl-4 cursor-pointer"
          onClick={() => navigate("/menu")}
        >
          <FaArrowLeftLong className="text-slate-400 text-[13px] " />
          <span className=" text-[13px] text-slate-400 font-bold  font-Roboto ">
            Volver al menú
          </span>
        </div>
        <div className="flex flex border-slate-200 gap-2 w-[100%] h-full flex justify-center items-center">
          <span className="first-letter:text-mariposa text-[22px] text-black font-bold  font-Roboto ">
            Mariposa
          </span>
          <span className="font-RobotoSlab font-[600] text-[22px]">
            Restaurant
          </span>
        </div>
        <div className="flex-col gap-4 px-2 py-2">
          <div className="text-[20px] border-b-[1px] border-slate-200 font-Roboto font-[500] flex">
            Carrito de Compras
          </div>
          <div>
            <div className="flex flex-col w-[100%] h-[90px] border-b-[1px] border-slate-200 justify-evenly">
              <div className="text-[18px] tracking-wide font-Roboto font-[400] flex">
                {products.length} Productos
              </div>
              <div className="leading-[16px] text-[20px] text-mariposa font-Roboto font-[500] flex flex-wrap">
                <span className="text-black mr-2 font-RobotoSlab text-[20px]">
                  Subtotal:{" "}
                </span>{" "}
                ${subtotal}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="h-full flex flex-col  bg-white last:border-b-[0px] py-2 px-2 gap-2">
        {products.map((product, index) => (
          <CartPageProduct product={product} key={index} />
        ))}
      </div>
    </div>
  );
};
